import { Component, Inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { ListagemRequisicaoFinanceira } from '@app/models/listagem-requisicao-financeira.model';
import { Instancia, Processo } from '@app/models/processo.model';
import { RequisicaoFinanceira, RequisicaoFinanceiraAdvogados, RequisicaoFinanceiraHistorico } from '@app/models/requisicao-financeira.model';
import { IdDescricao } from '@app/models/util/id-descricao';
import { ComunicacaoComponentesService } from '@app/services/comunicacao-componentes.service';
import { ConsultasService } from '@app/services/consultas.service';
import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';
import { ProcessoService } from '@app/services/processo.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { INgxSelectOption } from 'ngx-select-ex';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
@Component({
  selector: 'app-rpv',
  templateUrl: './rpv.component.html'
})
export class RpvComponent implements OnInit {
  private subscription: Subscription;
  private processoId: number = 0;

  @Input() processoArquivado: boolean = false;

  totalRequerido: number = 0;
  totalCliente: number = 0;
  totalEscritorio: number = 0;
  totalSubstabelecido: number = 0;
  totalEncaminhador: number = 0;
  totalAdvogados: number = 0;
  totalLiquido: number = 0;

  aguardando: boolean = false;

  lstRPV: ListagemRequisicaoFinanceira[] = [];
  lstHistorico: RequisicaoFinanceiraHistorico[] = [];
  lstErros: string[];

  lstInstancias: Instancia[];
  lstOrgaosJudiciario: IdDescricao[];
  lstAdvogados: IdDescricao[];

  objetoRPV: RequisicaoFinanceira = new RequisicaoFinanceira('RPV');
  historico: RequisicaoFinanceiraHistorico = new RequisicaoFinanceiraHistorico();

  @ViewChild('modalRpvForm', { static: true }) modalFormRef: TemplateRef<any>;
  modalRpvForm: BsModalRef;
  tituloModalRpvForm: string;

  @ViewChild('modalHistoricoForm', { static: true }) modalHistoricoFormRef: TemplateRef<any>;
  modalHistoricoForm: BsModalRef;
  tituloModalHistoricoForm: string;

  @ViewChild('modalHistorico', { static: true }) modalHistoricoRef: TemplateRef<any>;
  modalHistorico: BsModalRef;
  tituloModalHistorico: string;

  modalConfirmaExclusao: BsModalRef;

  constructor(
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private processoService: ProcessoService,
    private consultasService: ConsultasService,
    private financeiroProcessoService: FinanceiroProcessoService,
    private comunicacaoComponentesService: ComunicacaoComponentesService,
    private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.subscription = this.comunicacaoComponentesService.obtemClick().subscribe(
      (valor: number) => {
        if(valor === 2){
          this.inicializaComponente();
          this.subscription.unsubscribe();
        }
      });
  }

  //Métodos de busca
  inicializaComponente(){
    this.route.parent.params.subscribe((params) => {
      this.processoId = params['id'];
      this.obterTodos();
    }
    );
  }

  obterTodos(){
    this.financeiroProcessoService.obterTodosRPV(this.processoId).subscribe(
      (data) => {
        this.lstRPV = data;
        this.somaTotais(data);
      },
      () => this.toastr.error('Recarregue a página para tentar novamente.', 'Problema ao pesquisar!')
    );
  }

  //Métodos de criação e edição
  gravarRPV(){
    this.aguardando = true;
    this.objetoRPV.ProcessoId = this.processoId;

    if(!this.validaAdvogados()){
      this.aguardando = false;
      return;
    }

    if(!this.objetoRPV.DataAutuacao && this.objetoRPV.Recebido){
      this.toastr.error("Não é possivel marcar como recebido.", "Data de autuação obrigatória!");
      this.aguardando = false;
      return;
    }

    this.financeiroProcessoService.gravarRPV(this.objetoRPV).subscribe(
      () => {
        this.toastr.success(`RPV ${this.objetoRPV.Id > 0 ? 'editado' : 'criado'} com sucesso!`);
        this.obterTodos();
        this.fecharModalRpvForm();
      },
      (error) => {
        error.error.errors.length > 1 ?
        this.lstErros = error.error.errors :
        this.toastr.error(error.error.errors[0]);
        this.aguardando = false;
      }
    )
  }

  gravarHistorico(){
    this.aguardando = true;

    this.financeiroProcessoService.gravarHistoricoRequisicaoFinanceira(this.historico).subscribe(
      () => {
        this.aguardando = false;
        this.toastr.success(`Historico ${this.historico.Id > 0 ? 'editado' : 'adicionado'} com sucesso!`);
        this.fecharModalHistoricoForm();
      },
      () => { 
        this.aguardando = false;
        this.toastr.error('Não foi possível salvar histórico');
      }
    );
  }

  //Controles de modal
  abreConfirmarModal(rpvId: number){
    this.modalConfirmaExclusao = this.modalService.show(ModalConfirmarComponent);
    this.modalConfirmaExclusao.content.mensagem = 'Deseja realmente deletar este RPV?';
    this.modalConfirmaExclusao.content.confirmar = () => {
      this.financeiroProcessoService.excluirRequisicaoFinanceira(rpvId).subscribe(
        () => {
          this.toastr.success('RPV excluído com sucesso!');
          this.obterTodos();
        },
        (error) => this.toastr.error(error.error.errors[0])
      );
    };
  }

  abreModalRpvForm(rpvId: number = 0){
    const existente = rpvId > 0;

    if(existente){
      this.financeiroProcessoService.obterRequisicaoFinanceiraPorId(rpvId).subscribe(data => { 
        this.objetoRPV = data;
        this.objetoRPV.DataAutuacao = data.DataAutuacao?.split('T')[0];
        this.objetoRPV.DataPrevisaoRecebimento = data.DataPrevisaoRecebimento?.split('T')[0];
      });
    }

    this.consultasService.consultar('ORGAODOJUDICIARIO').subscribe(data => this.lstOrgaosJudiciario = data);
    this.consultasService.consultar('ADVOGADO').subscribe(data => this.lstAdvogados = data);
    this.processoService.ObterInstancias(this.processoId).subscribe(data => this.lstInstancias = data);

    this.tituloModalRpvForm = `${existente ? 'EDITAR' : 'NOVO'} RPV`;
    this.modalRpvForm = this.modalService.show(this.modalFormRef, {
        class: 'modal-lg',
        keyboard: false,
        ignoreBackdropClick: true
      });
  }

  fecharModalRpvForm(){
    this.modalRpvForm.hide();
    this.lstErros = [];
    this.objetoRPV = new RequisicaoFinanceira('RPV');
    this.lstInstancias = [];
    this.aguardando = false;
  }

  abreModalHistoricoFormCriacao(rpvId: number){
    this.tituloModalHistoricoForm = `ADICIONAR HISTÓRICO RPV Nº ${rpvId}`;
    this.historico.RequisicaoFinanceiraId = rpvId;

    this.modalHistoricoForm = this.modalService.show(this.modalHistoricoFormRef, {
      class: 'modal-md',
      keyboard: false,
      ignoreBackdropClick: true
    });
  }

  abreModalHistoricoFormEdicao(indexLista: number){
    let hist = this.lstHistorico[indexLista];
    this.tituloModalHistoricoForm = `EDITAR HISTÓRICO Nº ${hist.Id}`;
    this.historico.Id = hist.Id;
    this.historico.Descricao = hist.Descricao;

    this.modalHistoricoForm = this.modalService.show(this.modalHistoricoFormRef, {
      class: 'modal-md',
      keyboard: false,
      ignoreBackdropClick: true
    });
  }

  fecharModalHistoricoForm(){
    this.modalHistoricoForm.hide();
    if(this.historico.Id > 0)
      this.fecharModalHistorico();
    this.historico = new RequisicaoFinanceiraHistorico();
  }

  abreModalHistorico(rpvId: number){
    this.tituloModalHistorico = `HISTÓRICO RPV Nº ${rpvId}`
    this.financeiroProcessoService.obterHistoricoRequisicaoFinanceira(rpvId).subscribe(
      (data) => {
        this.lstHistorico = data;
        if(data.length > 0)
          this.modalHistorico = this.modalService.show(this.modalHistoricoRef, { class: 'modal-lg' });
        else
          this.toastr.info('RPV não possui histórico ainda');
      }
    );
  }

  fecharModalHistorico(){
    this.modalHistorico.hide();
  }

  //Controles de formulários
  searchCallback = (search: string, item: INgxSelectOption) => {
    if (search.trim() === '') {
      return true;
    } else {
      return item.text && item.text.toLowerCase().includes(search.toLowerCase());
    }
  }

  validaAdvogados(){
    const advogadoVazio = this.objetoRPV.HonorariosAdvogados.find(x => Number(x.PercentualAdvogado) === 0 || Number(x.AdvogadoId) === 0);
    
    if(advogadoVazio){
      this.toastr.error('Remova advogados não preenchidos!');
      this.aguardando = false;
      return false;
    }

    return true;
  }

  removerAdvogado(index: number) {
    this.objetoRPV.HonorariosAdvogados.splice(index, 1);
  }

  adicionarAdvogado() {
    const adv = new RequisicaoFinanceiraAdvogados(0, 0);
    this.objetoRPV.HonorariosAdvogados.push(adv);
  }

  completaCliente() {
    this.sanitizar();
    this.objetoRPV.PercentualCliente = Number((100 - this.objetoRPV.PercentualEscritorio).toFixed(2));
  }

  completaEscritorio() {
    this.sanitizar();
    this.objetoRPV.PercentualEscritorio = Number((100 - this.objetoRPV.PercentualCliente).toFixed(2));
  }

  sanitizar() {
    if (this.objetoRPV.PercentualCliente.toString().indexOf(','))
      this.objetoRPV.PercentualCliente = Number(this.objetoRPV.PercentualCliente.toString().replace(',', '.'));
    if (this.objetoRPV.PercentualEscritorio.toString().indexOf(','))
      this.objetoRPV.PercentualEscritorio = Number(this.objetoRPV.PercentualEscritorio.toString().replace(',', '.'));
  }

  private somaTotais(lista: ListagemRequisicaoFinanceira[]){
    this.zeraTotais();
    lista.forEach(item => {
      this.totalRequerido += item.ValorRequerido;
      this.totalCliente += item.ValorCliente;
      this.totalEscritorio += item.ValorEscritorio;
      this.totalEncaminhador += item.ValorEncaminhador;
      this.totalSubstabelecido += item.ValorSubstabelecido;
      this.totalAdvogados += item.ValorAdvogados;
      
    });

    this.totalLiquido = this.totalEscritorio - this.totalSubstabelecido - this.totalEncaminhador - this.totalAdvogados;
  }

  private zeraTotais(){
    this.totalRequerido = 0;
    this.totalCliente = 0;
    this.totalEscritorio = 0;
    this.totalEncaminhador = 0;
    this.totalSubstabelecido = 0;
    this.totalAdvogados = 0;
  }
  
}
